import type { ReactElement } from 'react'
import type { TFunction } from 'i18next'
import { Column } from 'primereact/column'
import Button from '../../../components/ui/Button'
import type { Prefix } from '../types'

interface ColumnOpts {
  t: TFunction
  onEdit: (row: Prefix) => void
  /** 126 — Kısıtlı Yetkili asistan: "Düzenle" kolonu hiç çizilmez (salt okunur). */
  readOnly?: boolean
}

/**
 * Ön Ek Tanımları tablosu sütunları (056) — **yalnız nesne adı ve ön ek**.
 *
 * Bilinçli olarak **yok olanlar**: hiçbir sütun `sortable` değildir (düzen sunucuda sabit `ID` artan —
 * FR-002a); **durum ve kimlik sütunu yoktur** (kullanıcı isteği + Clarifications Q5); satır
 * aksiyonlarında **yalnız Düzenle** vardır, "Sil" yoktur (FR-005).
 *
 * İki kolon da DB'de `NOT NULL` olduğundan boş hücre oluşamaz → yer tutucu sorusu doğmaz.
 */
export function prefixColumns({ t, onEdit, readOnly = false }: ColumnOpts): ReactElement[] {
  const columns = [
    <Column key="name" field="name" header={t('prefixes.columns.name')} />,
    <Column
      key="prefix"
      field="prefix"
      header={t('prefixes.columns.prefix')}
      style={{ width: '10rem' }}
    />,
  ]
  if (readOnly) return columns
  return [
    ...columns,
    <Column
      key="actions"
      header={t('prefixes.columns.actions')}
      style={{ width: '6rem' }}
      body={(row: Prefix) => (
        <div className="admin-row-actions">
          <Button
            icon="pi pi-pencil"
            rounded
            text
            label={t('prefixes.actions.edit')}
            aria-label={t('prefixes.actions.edit')}
            onClick={() => onEdit(row)}
          />
        </div>
      )}
    />,
  ]
}
